import React from "react";
import { Container, Grid, Typography, Box, Button } from "@mui/material";
import "./Loginpassword.css"; // Link to your CSS for animation
import { useNavigate } from "react-router-dom";

const Loginpassword = () => {
  const navigate = useNavigate();
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Box display={"flex"} justifyContent={"space-between"}>
        <Typography
          variant="h4"
          fontWeight="bold"
          textAlign="center"
          gutterBottom
        >
          Login & Password Security
        </Typography>
        <Button color="inherit" onClick={() => navigate("/helpcenterlayout")}>
          Back to Home
        </Button>
      </Box>

      <Grid container spacing={4} alignItems="center" mt={4}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Secure Entry with Password & TPIN
          </Typography>
          <Typography variant="body1" paragraph>
            Accessing your TA Wallet begins with a secure login process. Each
            session requires both your password and a Time-based Personal
            Identification Number (TPIN), offering strong two-layer
            authentication. This significantly reduces the risk of unauthorized
            access to your wallet.
          </Typography>
          <Typography variant="body1" paragraph>
            Once logged in, the system keeps your session protected with an
            active TPIN verification layer. Each sensitive action—such as bank
            detail updates, password changes, and high-value transactions—
            requires a fresh TPIN verification to proceed.
          </Typography>
          <Typography variant="body1" paragraph>
            Forgot your password or TPIN? No worries—our recovery system
            verifies your identity through registered mobile or email channels,
            and allows you to reset credentials securely.
          </Typography>
          <Typography variant="body1">
            Regularly updating your login credentials and TPIN ensures that your
            wallet remains safe, private, and accessible only to you. TA Wallet
            encourages best practices in password hygiene and account security.
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Box className="image-wrapper">
            <img
              src="/Assets/loginsecurity.jpg"
              alt="Login Security"
              className="animated-login-image"
            />
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Loginpassword;
